
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ActionButtons extends Vue {
  hasCancelSlotData() {
    return !!this.$slots["cancel"];
  }

  hasDefaultSlotData() {
    return !!this.$slots["default"];
  }

  get showActionButtons() {
    return this.hasCancelSlotData || this.hasDefaultSlotData;
  }
}
